import { render, staticRenderFns } from "./ConfEscalas.vue?vue&type=template&id=30aa3522"
import script from "./ConfEscalas.vue?vue&type=script&lang=js"
export * from "./ConfEscalas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports